(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.contact-form').forEach(function (contactForm) {
      const form = contactForm.querySelector('.contact-form__form');
      const btn = form ? form.querySelector('.contact-form__submit-btn') : null;
      const modal = contactForm.querySelector('[data-inquiry-success-modal]');
      const iframe = contactForm.querySelector('[data-contact-form-iframe]');
      const closeButton = contactForm.querySelector('[data-inquiry-modal-close]');
      const overlay = contactForm.querySelector('.inquiry-modal-overlay');

      if (!form || !btn || !modal || !iframe) return;

      const resetButton = function () {
        btn.classList.remove('loading');
        btn.querySelector('.btn-text').style.display = 'inline';
        btn.querySelector('.btn-loading').style.display = 'none';
      };

form.addEventListener('submit', function () {
  const email = form.querySelector('input[type="email"]');
  if (!email || !email.value) return;

  btn.classList.add('loading');
  btn.querySelector('.btn-text').style.display = 'none';
  btn.querySelector('.btn-loading').style.display = 'inline';

  iframe.onload = function () {
    setTimeout(function () {
      modal.style.display = 'block';
      form.reset();
      resetButton();
    }, 300);
  };
});



      if (closeButton) {
        closeButton.addEventListener('click', function () {
          modal.style.display = 'none';
        });
      }

      if (overlay) {
        overlay.addEventListener('click', function () {
          modal.style.display = 'none';
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
